import React, {useState} from 'react';
import CLButton from '../../CLButton/CLButton';
import './CLActionModalFooter.scss';
import useIsMounted from '../../../hooks/useIsMounted';
import {CLActionModalProps} from '../CLActionModal';
import {NoPermissionsButtonWrapper} from '../../../modules/roles/components/NoPermissionsButtonWrapper';
import CLOverlayTrigger from '../../CLOverlayTrigger/CLOverlayTrigger';

function CLActionModalFooter({
  okLabel = 'OK',
  cancelLabel = 'Cancel',
  modalAction,
  onCancel,
  isOkDisabled = false,
  isCancelDisabled = false,
  isShowCancel = false,
  isExecuting,
  isUserMissingPermission,
  okButtonTooltip,
  qaHook,
}: CLActionModalProps) {
  const [isExecutingModalAction, setIsExecutingModalAction] = useState(false);
  const isMounted = useIsMounted();

  return (
    <div className="cl_action_modal_footer">
      {modalAction && (
        <NoPermissionsButtonWrapper isUserWithPermission={!isUserMissingPermission}>
          <CLOverlayTrigger trigger="hover" popper={okButtonTooltip}>
            <CLButton
              isDisabled={isOkDisabled}
              label={okLabel}
              type="submit"
              isExecuting={isExecutingModalAction || isExecuting}
              buttonType="primary"
              onClick={() => {
                setIsExecutingModalAction(true);
                modalAction().finally(() => {
                  if (isMounted.current) {
                    setIsExecutingModalAction(false);
                  }
                });
              }}
              qaHook={qaHook && `${qaHook}-submit`}
            />
          </CLOverlayTrigger>
        </NoPermissionsButtonWrapper>
      )}
      {isShowCancel && (
        <CLButton
          label={cancelLabel}
          buttonType="secondary"
          onClick={onCancel}
          isDisabled={isCancelDisabled}
          qaHook={qaHook && `${qaHook}-cancel`}
        />
      )}
    </div>
  );
}

export default CLActionModalFooter;
